/**
* Dropdowns in twitter bootstrap 4.0 are not triggered with hover events.
* This js file adds that feature on large screen devices along with optional animation styles.
*
* animations have been included from animate.css https://daneden.github.io/animate.css/
* some pairs of animations don't work well with eachother
*
* mobile uses jQuery slideUp and slideDown
*/

jQuery(function( $ ) {
    "use strict"

    var navbarDropdownShowAnimation = 'slideDown', // can be slideDown or a show animation from animate.css
        navbarDropdownHideAnimation = 'fadeOut', // can be slideUp or a hide animation from animate.css
        animationSpeed              = 200, // also set in _navbar-nav.scss for use with animate.css
        animationDelayOnMouseLeave  = 100; // this is the delay after mouseleave to avoid jerky animations

    /*******************************************************************************************************************
    DON'T EDIT BELOW THIS LINE
    /*******************************************************************************************************************

    /**
    * Attaches show animation to click and keyboard show events
    * Bootstrap adds .show to dropdown and dropdownMenu after this function executes
    */
    $( '.navbar-nav .dropdown' ).on( 'show.bs.dropdown', function() {
        var dropdown        = $( this ),
            dropdownMenu    = $( this ).children( '.dropdown-menu' );

        // reset after jQuery slideUp - may have been mobile or chosen animation
        dropdownMenu.css( 'display', '' );

        if ( ! sb_isDesktop() || 'slideDown' == navbarDropdownShowAnimation ) {
            // use jQuery
            dropdownMenu.stop().hide().slideDown( animationSpeed );
        } else {
            // use animate.css
            dropdownMenu.animateCss( navbarDropdownShowAnimation );
        }
    });

    /*
    * Attaches hide animation to click and keyboard hide events
    * We are removing .show from dropdown and dropdownMenu in the method after the animation
    */
    $( '.navbar-nav .dropdown' ).on( 'hide.bs.dropdown', function(e) {
        e.preventDefault();

        var dropdown        = $( this ),
            dropdownMenu    = dropdown.children( '.dropdown-menu' );

        // reset after jQuery slideUp - may have been mobile or chosen animation
        dropdownMenu.css( 'display', '' );

        if ( ! sb_isDesktop() || 'slideUp' === navbarDropdownHideAnimation ) {
            // use jQuery
            dropdownMenu.slideUp( animationSpeed, function() {
                dropdown.removeClass( 'show' );
                dropdownMenu.removeClass( 'show' );
            });
        } else {
            // use animate.css
            dropdownMenu.animateCss( navbarDropdownHideAnimation, function() {
                dropdown.removeClass( 'show' );
                dropdownMenu.removeClass( 'show' ).removeClass( navbarDropdownHideAnimation );
            });
        }
    });

    /*
    * Attaches show animation to hover mouseenter events
    */
    $( '.navbar-nav .dropdown' ).on( 'mouseenter', function(e) {
        e.preventDefault();

        var dropdown        = $( this ),
            dropdownMenu    = dropdown.children( '.dropdown-menu' );

        if ( ! sb_isDesktop() || dropdown.hasClass( 'show' ) ) {
            return;
        }

        // reset after jQuery slideUp - may have been mobile or chosen animation
        dropdownMenu.css( 'display', '' );

        if ( 'slideDown' === navbarDropdownShowAnimation ) {
            // use jQuery
            dropdownMenu.stop().hide().slideDown( animationSpeed );
        } else {
            // use animate.css
            dropdownMenu.animateCss( navbarDropdownShowAnimation );
        }

        dropdown.addClass( 'show' );
        dropdownMenu.addClass( 'show' );
    });

    /*
    * Attaches hide animation to hover mouseleave events
    */
    $( '.navbar-nav .dropdown' ).on( 'mouseleave', function(e) {
        e.preventDefault();

        var dropdown        = $( this ),
            dropdownMenu    = dropdown.children( '.dropdown-menu' );

        if ( ! sb_isDesktop() || ! dropdown.hasClass( 'show' ) ) {
            return;
        }

        setTimeout( function() {
            if ( dropdown.is( ':hover' ) ) {
                return;
            }
            // reset after jQuery slideUp - may have been mobile or chosen animation
            dropdownMenu.css( 'display', '' );

            if ( 'slideUp' == navbarDropdownHideAnimation ) {
                // use jQuery
                dropdownMenu.slideUp( animationSpeed, function() {
                    dropdown.removeClass( 'show' );
                    dropdownMenu.removeClass( 'show' );
                });
            } else {
                // use animate.css
                dropdownMenu.animateCss( navbarDropdownHideAnimation, function() {
                    dropdown.removeClass( 'show' );
                    dropdownMenu.removeClass( 'show' ).removeClass( navbarDropdownHideAnimation );
                });
            }
        }, animationDelayOnMouseLeave ); // this is the delay after mouseleave to avoid jerky animations
    });


});
